import { render, staticRenderFns } from "./order-card.vue?vue&type=template&id=1cda17bc&scoped=true&"
import script from "./order-card.vue?vue&type=script&lang=js&"
export * from "./order-card.vue?vue&type=script&lang=js&"
import style0 from "./order-card.vue?vue&type=style&index=0&id=1cda17bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cda17bc",
  null
  
)

export default component.exports